module.exports = __webpack_public_path__ + "static/img/testimony (29).aaa4e702.jpg";